import { useState } from "react";

const faqs = [
  {
    q: "Who are advisory services for?",
    a: "Our advisory services are designed for a broad range of clients united by a common goal &mdash; building lasting, intergenerational wealth with clarity and purpose. This includes African Diaspora professionals, families and family offices, entrepreneurs, emerging investors, existing investors seeking diversification, and strategic partners aligned with our mission.",
  },
  {
    q: "Do I need to be an experienced investor to access advisory services?",
    a: "Not at all. Our advisory model is designed to meet clients at every stage of their journey. Whether you are just beginning to think about wealth-building or you are an experienced investor seeking structured cross-border guidance, we have a pathway for you. We begin with education and trust-building, so no prior investment experience is required.",
  },
  {
    q: "Is this only for diaspora clients?",
    a: "While our mission is centered on the African Diaspora, our advisory services are open to any individual, family, or organization aligned with our values and goals. We welcome emerging investors, entrepreneurs, and strategic partners from across the globe who are interested in cross-border wealth creation and African market opportunities.",
  },
  {
    q: "Do you offer family office support?",
    a: "Yes. Family office support is one of our core advisory areas. We provide guidance for families seeking to establish or strengthen family office structures, governance frameworks, and intergenerational wealth transfer strategies. This is typically accessed through our phased advisory model, after an initial consultation and readiness assessment.",
  },
  {
    q: "How do I get started?",
    a: "Getting started is simple. Complete the consultation inquiry form on this page, and our team will reach out within 2&ndash;3 business days to schedule your initial conversation. There is no commitment required &mdash; the first consultation is simply about understanding your goals and whether Harambee is the right fit for your journey.",
  },
  {
    q: "Does Harambee manage client funds or provide investment advice?",
    a: "No. Harambee Global Ventures provides educational and advisory services only. We do not manage client funds, offer personalized investment advice, or make any guarantees about financial outcomes. Our role is to educate, guide, and support &mdash; all investment decisions remain the responsibility of the individual client.",
  },
];

export default function AdvisoryFAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-5 gap-14">
        {/* Left */}
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            FAQ
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
            Have a question that isn&apos;t answered here? We are happy to help. Reach out directly and our team will respond promptly.
          </p>
          <a
            href="#consult"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-[#1A4D3C] text-white text-sm font-medium hover:bg-[#0D2E1E] transition-colors whitespace-nowrap cursor-pointer"
          >
            Ask Us Directly <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* Right - Accordion */}
        <div className="lg:col-span-3 space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white border border-[#E8E4DC] rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer group"
              >
                <span className="font-medium text-[#2B2D2F] text-sm pr-4 group-hover:text-[#1A4D3C] transition-colors">
                  {faq.q}
                </span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#F8F6F3] flex-shrink-0">
                  <i
                    className={`text-[#1A4D3C] text-base transition-transform duration-300 ${
                      open === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </div>
              </button>
              {open === i && (
                <div className="px-7 pb-6">
                  <p
                    className="text-[#6B6B6B] text-sm leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: faq.a }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
